import styled from '@emotion/styled';

export default styled.div`
  display: flex;
  height: 50vh;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
